var Moment = require('moment');

require('moment-timezone');

module.exports = Moment;